export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14861.68c51c32.jpg";